import { TableColumn } from '@shared/components/data-table/data-table.component';

// ============================================================================
// TABLE COLUMN CONFIGURATION
// ============================================================================

/**
 * Default column property names (shown on first load)
 * Update these constants to change column property names
 */
export const ALERT_SETTINGS_DEFAULT_COLUMNS = {
  SCOPE: 'scope',
  SKU_CODE: 'skuCode',
  SKU_NAME: 'skuName',
  WAREHOUSE_NAME: 'warehouseName',
  NAME: 'name',
  DESCRIPTION: 'description',
  MIN_STOCK: 'minStock',
  MAX_STOCK: 'maxStock',
} as const;

/**
 * Flexible column property names (can be shown/hidden via column selector)
 * Update these constants to change flexible column property names
 */
export const ALERT_SETTINGS_FLEXIBLE_COLUMNS = {
  CREATION_DATE: 'creationDate',
} as const;

/**
 * Action column property name
 */
export const ALERT_SETTINGS_ACTION_COLUMN = {
  ACTIONS: 'actions',
} as const;

/**
 * Default columns order (shown on first load)
 * Update this array to change the default column order
 */
export const ALERT_SETTINGS_DEFAULT_COLUMNS_ORDER: string[] = [
  ALERT_SETTINGS_DEFAULT_COLUMNS.SCOPE,
  ALERT_SETTINGS_DEFAULT_COLUMNS.SKU_CODE,
  ALERT_SETTINGS_DEFAULT_COLUMNS.SKU_NAME,
  ALERT_SETTINGS_DEFAULT_COLUMNS.WAREHOUSE_NAME,
  ALERT_SETTINGS_DEFAULT_COLUMNS.NAME,
  ALERT_SETTINGS_DEFAULT_COLUMNS.DESCRIPTION,
  ALERT_SETTINGS_DEFAULT_COLUMNS.MIN_STOCK,
  ALERT_SETTINGS_DEFAULT_COLUMNS.MAX_STOCK,
];

/**
 * Flexible columns array (can be shown/hidden via column selector)
 * Update this array to change which columns are flexible
 */
export const ALERT_SETTINGS_FLEXIBLE_COLUMNS_ORDER: string[] = [
  ALERT_SETTINGS_FLEXIBLE_COLUMNS.CREATION_DATE,
];

export const ALERT_SETTINGS_COLUMNS: TableColumn[] = [
  {
    label: 'alert_settings.table.scope',
    prop: ALERT_SETTINGS_DEFAULT_COLUMNS.SCOPE,
    width: 150,
  },
  {
    label: 'alert_settings.table.sku_code',
    prop: ALERT_SETTINGS_DEFAULT_COLUMNS.SKU_CODE,
    width: 150,
  },
  {
    label: 'alert_settings.table.sku_name',
    prop: ALERT_SETTINGS_DEFAULT_COLUMNS.SKU_NAME,
    width: 200,
  },
  {
    label: 'alert_settings.table.warehouse_name',
    prop: ALERT_SETTINGS_DEFAULT_COLUMNS.WAREHOUSE_NAME,
    width: 180,
  },
  {
    label: 'alert_settings.table.name',
    prop: ALERT_SETTINGS_DEFAULT_COLUMNS.NAME,
    width: 150,
  },
  {
    label: 'alert_settings.table.description',
    prop: ALERT_SETTINGS_DEFAULT_COLUMNS.DESCRIPTION,
    width: 200,
  },
  {
    label: 'alert_settings.table.min_stock',
    prop: ALERT_SETTINGS_DEFAULT_COLUMNS.MIN_STOCK,
    width: 110,
    type: 'number',
  },
  {
    label: 'alert_settings.table.max_stock',
    prop: ALERT_SETTINGS_DEFAULT_COLUMNS.MAX_STOCK,
    width: 110,
    type: 'number',
  },
  {
    label: 'alert_settings.table.creation_date',
    prop: ALERT_SETTINGS_FLEXIBLE_COLUMNS.CREATION_DATE,
    width: 135,
    type: 'custom',
    template: 'dateTemplate',
  },
  {
    label: 'alert_settings.table.actions',
    prop: ALERT_SETTINGS_ACTION_COLUMN.ACTIONS,
    type: 'actions',
    width: 120,
  },
];
